import { useAppState } from "..";

export function useChats() {
  const state = useAppState();

  return state.chats;
}
